/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { isIOS } from 'react-device-detect';

const Input = ({
  label = '',
  subLabel = null,
  className = '',
  errorLabel = null,
  value,
  withFloatingLabel = false,
  withSubLabel = false,
  withErrorLabel = false,
  onChange,
  actionLabel,
  actionClick = null,
  actionDisabled = false,
  groupClassName = '',
  inputGroupChildren = null,
  actionBtnTop = '33%',
  actionBtnRight = '0',
  containerClass = '',
  containerStyle = null,
  inputRef = {},
  ...props
}) => (
  <div className={`position-relative ${containerClass}`} style={containerStyle}>
    <div className={`form-group ${groupClassName}`}>
      <input
        className={`form-control-input ${className}`}
        placeholder={props.placeholder || label}
        value={value}
        onChange={onChange}
        ref={inputRef}
        {...props}
      />
      {withFloatingLabel && <label className="floating-label">{label}</label>}
      {withErrorLabel && <label className="error-label">{errorLabel}</label>}
      {withSubLabel && <label className="text-f6 text-shadow mt-1 mw-75">{subLabel}</label>}
      {inputGroupChildren}
    </div>
    {actionClick && (
      <button
        type="button"
        className={`text-f6 text-dark btn btn-outline-shadow position-absolute py-2 translate-middle-y darken-shadow-hover text-bold custom-resend-btn ${
          isIOS ? 'ios' : ''
        }`}
        style={{ top: actionBtnTop, right: actionBtnRight }}
        onClick={actionClick}
        disabled={actionDisabled}>
        {actionLabel}
      </button>
    )}
  </div>
);

export default Input;

Input.propTypes = {
  label: PropTypes.string,
  subLabel: PropTypes.string,
  className: PropTypes.string,
  errorLabel: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  actionLabel: PropTypes.string,
  actionClick: PropTypes.func,
  actionDisabled: PropTypes.bool,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  groupClassName: PropTypes.string,
  withFloatingLabel: PropTypes.bool,
  withSubLabel: PropTypes.bool,
  withErrorLabel: PropTypes.bool,
  inputGroupChildren: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  actionBtnTop: PropTypes.string,
  actionBtnRight: PropTypes.string,
  containerClass: PropTypes.string,
  inputRef: PropTypes.object,
  containerStyle: PropTypes.string,
};
